import * as React from 'react';
import { parseHtml } from '@grandvisionhq/lib-utils-html';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';

const CountdownLabels = ({ showDays , showHours , showMinutes , showSeconds  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "cdt__labels"
    }, showDays && /*#__PURE__*/ React.createElement("span", {
        className: "cdt__label",
        "data-t": "cdt-label-days"
    }, getLabel('common.countdown.unit.days')), showHours && /*#__PURE__*/ React.createElement("span", {
        className: "cdt__label",
        "data-t": "cdt-label-hours"
    }, getLabel('common.countdown.unit.hours')), showMinutes && /*#__PURE__*/ React.createElement("span", {
        className: "cdt__label",
        "data-t": "cdt-label-minutes"
    }, getLabel('common.countdown.unit.minutes')), showSeconds && /*#__PURE__*/ React.createElement("span", {
        className: "cdt__label",
        "data-t": "cdt-label-seconds"
    }, getLabel('common.countdown.unit.seconds')));
};
const CountdownSection = ({ name , value , layout , hasColon  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "cdt__time-section"
    }, /*#__PURE__*/ React.createElement("span", {
        className: `cdt__time-section__number cdt__time-section__number-${layout}`,
        "data-t": `cdt-number-${name}`
    }, formatTime(value), hasColon && /*#__PURE__*/ React.createElement("span", {
        className: `cdt__time-colon cdt__time-section__colon-${layout}`
    }, ":"))));
};
const CountdownContainer = ({ showDays , showHours , showMinutes , showSeconds , layout , timeLeft  })=>{
    const showLabels = layout !== 'slim';
    return /*#__PURE__*/ React.createElement("div", {
        className: "cdt__right-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: `cdt__timer-container cdt__timer-container-${layout}`
    }, showDays && /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "days",
        value: timeLeft.days,
        layout: layout,
        hasColon: true
    }), showHours && /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "hours",
        value: timeLeft.hours,
        layout: layout,
        hasColon: true
    }), showMinutes && /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "minutes",
        value: timeLeft.minutes,
        layout: layout,
        hasColon: true
    }), showSeconds && /*#__PURE__*/ React.createElement(CountdownSection, {
        name: "seconds",
        value: timeLeft.seconds,
        layout: layout
    })), showLabels && /*#__PURE__*/ React.createElement(CountdownLabels, {
        showDays: showDays,
        showHours: showHours,
        showMinutes: showMinutes,
        showSeconds: showSeconds
    }));
};
const calculateTimeLeft = (endDate)=>{
    const total = new Date(endDate).getTime() - new Date().getTime();
    const seconds = Math.floor(total / 1000 % 60);
    const minutes = Math.floor(total / 1000 / 60 % 60);
    const hours = Math.floor(total / (1000 * 60 * 60) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    return {
        end: total <= 0,
        days: Math.max(0, days),
        hours: Math.max(0, hours),
        minutes: Math.max(0, minutes),
        seconds: Math.max(0, seconds)
    };
};
const formatTime = (time)=>String(time).padStart(2, '0')
;
const CountdownTimer = ({ endDate , countdownText , showCountdown , url , layout ,  })=>{
    const isClient = useIsClient();
    const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft(endDate));
    //For future updates, this will allow the customer to decide whether they want to display all or just a few values
    const showDays = true;
    const showHours = true;
    const showMinutes = true;
    const showSeconds = true;
    React.useEffect(()=>{
        const timer = setInterval(()=>{
            const { hours , days , minutes , seconds , end  } = calculateTimeLeft(endDate);
            if (end) {
                clearInterval(timer);
            }
            setTimeLeft({
                hours,
                days,
                minutes,
                seconds,
                end
            });
        }, 1000);
        return ()=>clearInterval(timer)
        ;
    }, [
        endDate
    ]);
    if (!(isClient && showCountdown && timeLeft)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("a", {
        href: url,
        className: "cdt",
        "data-t": "cdt"
    }, /*#__PURE__*/ React.createElement("div", {
        className: `cdt__content cdt__content-${layout}`
    }, /*#__PURE__*/ React.createElement("div", {
        className: `cdt__text-container cdt__text-container-${layout}`
    }, parseHtml(countdownText.value)), /*#__PURE__*/ React.createElement(CountdownContainer, {
        layout: layout,
        timeLeft: timeLeft,
        showDays: showDays,
        showHours: showHours,
        showMinutes: showMinutes,
        showSeconds: showSeconds
    })));
};

export { CountdownTimer as default };
//# sourceMappingURL=CountdownTimer.js.map
